import { IconContent } from '@icons';

export const user: IconContent = {
    sm: '<path fill-rule="evenodd" d="M10.5 4.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm1 0a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-8.5 9A3.5 3.5 0 0 1 6.5 10h3a3.5 3.5 0 0 1 3.5 3.5v.5h1v-.5A4.5 4.5 0 0 0 9.5 9h-3A4.5 4.5 0 0 0 2 13.5v.5h1v-.5Z" />',
    md: '<path fill-rule="evenodd" d="M14.5 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm1 0a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-8.5 9a3.5 3.5 0 0 1 3.5-3.5h3a3.5 3.5 0 0 1 3.5 3.5v.5h1v-.5a4.5 4.5 0 0 0-4.5-4.5h-3A4.5 4.5 0 0 0 6 17.5v.5h1v-.5Z" />',
};
